import { render, staticRenderFns } from "./tenderList.vue?vue&type=template&id=6748f548&scoped=true&"
import script from "./tenderList.vue?vue&type=script&lang=js&"
export * from "./tenderList.vue?vue&type=script&lang=js&"
import style0 from "./tenderList.vue?vue&type=style&index=0&id=6748f548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6748f548",
  null
  
)

export default component.exports